import React, {useState, useEffect} from 'react'
import Container from '../../components/Container';
import Calculator from '../../components/Calculator';
import {getPercentEndTerm, getPercentMouthPayment} from '../../helpers/getPercentDeposit';

import Fire from '../../images/fire.png';

import './index.scss';
import classNames from 'classnames';

const Main = () => {

    const [currency, setCurrency] = useState('uah');
    const [sum, setSum] = useState('');
    const [term, setTerm] = useState(12);
    const [count, setCount] = useState(6);
    const [replenishment, setReplenishment] = useState(false);
    const [early, setEarly] = useState(true);
    const [procentEndTerm, setProcentEndTerm] = useState(false);
    const [tax, setTax] = useState(false);
    const [result, setResult] = useState(null);

    //BALLOONS

    const [ballon7, showBallon7] = useState(false);
    const [ballon8, showBallon8] = useState(false);
    const [ballon9, showBallon9] = useState(false);
    const [ballon10, showBallon10] = useState(false);
    const reg = /^\d+$/;
    useEffect(() => {
        calculate(sum, term, replenishment, early, currency, procentEndTerm)
    }, [currency, sum, term, replenishment, early, procentEndTerm])

    const handleCurrency = (value) => {
        setCurrency(value);
    }

    const handleSum = (value) => {
        setSum(value.replaceAll(' ', ''));
    }

    const handleTerm = (value) => {
        if(!value) {
            return
        }
        const t = value[0];
        setCount(t)

        if(t === 1) {
            setTerm(0.23)
        }
        else if(t === 2) {
            setTerm(1)
        }
        else if (t === 3) {
            setTerm(3)
        }
        else if (t === 4) {
            setTerm(6)
        }
        else if (t === 5) {
            setTerm(9)
        }
        else if (t === 6) {
            setTerm(12)
        }
        else if (t === 7) {
            setTerm(18)
        }
        else if (t === 8) {
            setTerm(24)
        }
    }

    const handleReplenishment = (value) => {
        setReplenishment(value);
    }

    const handleEarly = (value) => {
        setEarly(value);
    }
    
    const handleProcent = (value) => {
        setProcentEndTerm(value);
    }

    const handleTax = (value) => {
        setTax(value)
    }

    const calculate = (sum, term, replenishment, early, currency, procentEndTerm) => {
        
        if(!sum || sum < 0 || (sum < 1000 && currency === 'uah') || (sum < 100 && (currency === 'usd' || currency === 'eur'))) {
            return {
                amount: '--',
                payTaxes: '--',
                profit: '--',
                percent: '--',
                endTerm: '--',
                percentSum: '--'
            }
        }

        const percent = early ? getPercentEndTerm(term, currency, replenishment, procentEndTerm) : getPercentMouthPayment(term, currency, replenishment, procentEndTerm);
        
        let amount, payTaxes, profit, endTerm, percentSum, taxWithholdingRate;
        amount = (percent * 0.01) * sum * term / 12;
        payTaxes = Number(amount) * (19.50 * 0.01);
        profit = Number(amount) - Number(payTaxes);
        endTerm = Number(sum) + Number(profit);
        percentSum = (percent * 0.01) * sum / 12;
        taxWithholdingRate = (percent - (percent * 0.195))

        amount = Number(amount).toFixed(2);
        payTaxes = Number(payTaxes).toFixed(2);
        profit = Number(profit).toFixed(2);
        endTerm = Number(endTerm).toFixed(2);
        percentSum = Number(percentSum).toFixed(2);
        taxWithholdingRate = Number(taxWithholdingRate).toFixed(2);

        if(replenishment && procentEndTerm) {
            if(!ballon7) {
                showBallon7(true);
            }
        }
        if(!replenishment && procentEndTerm) {
            if(!ballon8) {
                showBallon8(true);
            }
        }
        if(replenishment && !procentEndTerm) {
            if(!ballon9) {
                showBallon9(true);
            }
        }
        if(!replenishment && !procentEndTerm) {
            if(!ballon10) {
                showBallon10(true);
            }
        }

        return setResult({
            amount: Number(amount),
            payTaxes: Number(payTaxes),
            profit: Number(profit),
            percent: Number(percent),
            endTerm: Number(endTerm),
            percentSum: Number(percentSum),
            taxWithholdingRate: Number(taxWithholdingRate)
        })
    }

    const jumpToOrder = () => {
        document.querySelector('.order').scrollIntoView({
            behavior: 'smooth'
        });
    }

    return (
        <div className="main">
            <Container>
                <div className="main__wrapper">
                    <div className="main__calculator">
                        <div className="main__calculator-title bold">
                            Хочу заробити ще
                            <img src={Fire} alt={'icon fire'} />
                        </div>
                        <Calculator 
                            cur={currency} 
                            changeCurrency={handleCurrency} 
                            sum={sum} 
                            changeSum={handleSum} 
                            term={count} 
                            changeTerm={handleTerm} 
                            replenishment={replenishment}
                            changeReplenishment={handleReplenishment}
                            early={early}
                            changeEarly={handleEarly}
                            procent={procentEndTerm}
                            changeProcentEndTerm={handleProcent}
                            tax={tax}
                            changeTax={handleTax}
                            result={result}
                            />
                    </div>
                    <div className="main__balloons">
                        <div className="main__balloons-container">
                            <div className={classNames('balloon', {'balloon--7': ballon7}, {'balloon--active': (procentEndTerm && replenishment && ballon7)}, {'balloon--show': ballon7})} id="balloon-7">
                                <div className="balloon-title medium">
                                    <span className="bold">{early ? getPercentEndTerm(term, currency, true, true) : getPercentMouthPayment(term, currency, true, true)}%</span> з поповненням та достроковим зняттям
                                </div>
                                <div className="thread"></div>
                            </div>
                            <div className={classNames('balloon', {'balloon--8': ballon8}, {'balloon--active': (procentEndTerm && !replenishment && ballon8)}, {'balloon--show': ballon8})} id="balloon-8">
                                <div className="balloon-title medium">
                                    <span className="bold">{early ? getPercentEndTerm(term, currency, false, true) : getPercentMouthPayment(term, currency, false, true)}%</span> з достроковим зняттям
                                </div>
                                <div className="thread"></div>
                            </div>
                            <div className={classNames('balloon', {'balloon--9': ballon9}, {'balloon--active': (replenishment && !procentEndTerm && ballon9)}, {'balloon--show': ballon9})} id="balloon-9">
                                <div className="balloon-title medium">
                                    <span className="bold">{early ? getPercentEndTerm(term, currency, true, false) : getPercentMouthPayment(term, currency, true, false)}%</span> з поповненням
                                </div>
                                <div className="thread"></div>
                            </div>
                            <div className={classNames('balloon ', {'balloon--10': ballon10}, {'balloon--active': (!replenishment && !procentEndTerm && ballon10)}, {'balloon--show': ballon10})} id="balloon-10">
                                <div className="balloon-title medium">
                                    <span className="bold">{early ? getPercentEndTerm(term, currency, false, false) : getPercentMouthPayment(term, currency, false, false)}%</span> максимальный дохід
                                </div>
                                <div className="thread"></div>
                            </div>
                        </div>
                        <div className="main__balloons-control">
                            <button onClick={() => jumpToOrder()} className="main__balloons-btn bold">Оформити</button>
                        </div>
                    </div>    
                </div>  
            </Container>
        </div>
    )
}

export default Main